

















import { Component, Vue, Prop } from 'vue-property-decorator';
import BlockContent from 'sanity-blocks-vue-component';
import setWelcomeCampaign from '~/mutations/setWelcomeCampaign.gql';

@Component({
  components: { BlockContent },
})
export default class CampaignDialog extends Vue {
  @Prop(Array) content!: any[];

  created() {
    this.removeCampaignFromUser();
  }

  async removeCampaignFromUser() {
    await this.$apollo.mutate({ mutation: setWelcomeCampaign });
  }
}
